<template>
  <div class="skills-list" v-smooth-appear="{elements: '.smooth-appear-project', wait: 200, duration: 500, delay: 10, translate: 30}">
    <template v-for="(item, index) in items">
      <br v-if="item === '<br>'" :key="index" />
      <div v-else class="item smooth-appear-project" :key="index">
        {{ item }}
      </div>
    </template>
  </div>
</template>

<script>
import SmoothAppear from '@/directives/SmoothAppear'

export default {
  props: ['items'],
  directives: {
    SmoothAppear
  }
}
</script>

<style scoped>

.skills-list {
}
.item {
  display: inline-block;
  padding: 5px 10px;
  cursor: default;
  white-space: nowrap;
  /* transition: all 0.5s ease; */
}
.item:hover {
  /* transform: scale(1.2); */
}
</style>



// WEBPACK FOOTER //
// SkillsList.vue?7200464a